// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_layouts_admin-layout_admin-layout_module_ts":"9039aeb26007725f","src_app_layouts_auth-layout_auth-layout_module_ts":"2c17601e8b0e9d82"}[chunkId] + ".js";
};